export default function FilterBar({ brands, filters, sort, onChange, onSort, shown, total }) {
  const set = (k, v) => onChange({ ...filters, [k]: v });

  return (
    <div className="filter-bar">
      <div className="filter-group">
        <span className="filter-label">Brand</span>
        <select className="filter-select" value={filters.brand} onChange={e => set("brand", e.target.value)}>
          <option value="">All Brands</option>
          {brands.map(b => <option key={b}>{b}</option>)}
        </select>
      </div>
      <div className="filter-group">
        <span className="filter-label">Min £</span>
        <input type="number" min={0} className="filter-num" value={filters.minPrice}
          onChange={e => set("minPrice", +e.target.value)} />
      </div>
      <div className="filter-group">
        <span className="filter-label">Max £</span>
        <input type="number" min={0} className="filter-num" value={filters.maxPrice}
          onChange={e => set("maxPrice", +e.target.value)} />
      </div>
      <div className="filter-group">
        <span className="filter-label">Min Rating</span>
        <select className="filter-select" value={filters.minRating} onChange={e => set("minRating", +e.target.value)}>
          <option value={0}>Any</option>
          <option value={3}>3★+</option>
          <option value={4}>4★+</option>
          <option value={4.5}>4.5★+</option>
        </select>
      </div>
      <div className="filter-group">
        <span className="filter-label">Sort By</span>
        <select className="filter-select" value={sort} onChange={e => onSort(e.target.value)}>
          <option value="pop">Most Popular</option>
          <option value="rating">Highest Rated</option>
          <option value="price_a">Price: Low → High</option>
          <option value="price_d">Price: High → Low</option>
        </select>
      </div>
      <div className="filter-count">
        {shown === total ? `${total} products` : `${shown} of ${total}`}
      </div>
    </div>
  );
}
